import React from 'react';
import { Typography } from 'antd';
import ReactMarkdown from 'react-markdown';

import styles from './screenheading.module.css';

const { Title, Paragraph } = Typography;

interface ScreenHeadingProps {
  title: string,
  description?: string,
  image?: string,
  replaceTokens(input: string): string
}

class ScreenHeading extends React.Component<ScreenHeadingProps> {

  render() {
    const { title, description, image, replaceTokens } = this.props;
    return <div className={styles.screenHeading}>
      <Title className={`${styles.title} qr-text qr-title`} level={2}>
          <ReactMarkdown components={{ a: props => <a href={props.href} rel="noopener noreferrer" target="_blank">{props.children}</a>}}>{replaceTokens(title)}</ReactMarkdown>
      </Title>
      { !!image && <img src={replaceTokens(image)} className={`${styles.image} qr-image`} alt={`Imagen: ${title}`} />}
      { !!description && <Paragraph className={`${styles.subtitle} qr-text qr-subtitle`}>
        <ReactMarkdown components={{ a: props => <a href={props.href} rel="noopener noreferrer" target="_blank">{props.children}</a>}}>{replaceTokens(description)}</ReactMarkdown>
      </Paragraph>}
    </div>;
  }
}

export default ScreenHeading;
